import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCollections } from '../../firebase/database';

const Footer = () => {
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    getCollections().then(setCollections).catch(() => setCollections([]));
  }, []);

  const links = {
    company: [
      { label: 'About Us', to: '/about' },
      { label: 'Collections', to: '/collections' },
      { label: 'FAQs', to: '/faqs' },
      { label: 'Contact Us', to: '/contact' },
    ],
    policies: [
      { label: 'Shipping Policy', to: '/shipping-policy' },
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Terms & Conditions', to: '/terms' },
    ],
  };

  return (
    <footer className="bg-[#0f2347] text-white">
      {/* Newsletter */}
      <div className="bg-[#e63946] py-8">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <h3 className="font-display text-xl font-bold">Get Exclusive Deals</h3>
            <p className="text-sm text-red-100">Subscribe for new arrivals, special offers & more</p>
          </div>
          <form className="flex w-full md:w-auto gap-0" onSubmit={e => e.preventDefault()}>
            <input type="email" placeholder="Enter your email" className="flex-1 md:w-72 px-4 py-3 text-gray-900 text-sm outline-none"/>
            <button className="px-6 py-3 bg-[#1a3a6e] text-white text-sm font-bold hover:bg-[#0f2347] transition-colors whitespace-nowrap">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img src="/logo.png" alt="SitSmart" className="h-16 w-auto object-contain mb-2 bg-white p-1.5 rounded-lg" />
            <p className="text-gray-400 text-sm leading-relaxed mb-6 max-w-xs">
              Pakistan's premier smart seating brand. Durable, comfortable, and stylish furniture for every home and office.
            </p>
            <div className="space-y-3">
              {[
                { icon: <svg className="w-4 h-4 text-[#e63946] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>, text: '+92 333 1420200', href: 'tel:+923331420200' },
                { icon: <svg className="w-4 h-4 text-[#e63946] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>, text: 'info@sitsmart.store', href: 'mailto:info@sitsmart.store' },
                { icon: <svg className="w-4 h-4 text-[#e63946] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>, text: 'Karachi, Sindh, Pakistan' },
              ].map(({ icon, text, href }) => (
                <div key={text} className="flex items-start gap-3 text-gray-400 text-sm">
                  {icon}
                  {href ? <a href={href} className="hover:text-white transition-colors">{text}</a> : <span>{text}</span>}
                </div>
              ))}
            </div>
            {/* Social */}
            <div className="flex items-center gap-3 mt-6">
              {[
                { href: 'https://facebook.com/sitsmartstore', icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg> },
                { href: 'https://instagram.com/sitsmart.store', icon: <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg> },
              ].map(({ href, icon }) => (
                <a key={href} href={href} target="_blank" rel="noopener noreferrer"
                  className="w-9 h-9 border border-gray-600 flex items-center justify-center text-gray-400 hover:border-[#e63946] hover:text-[#e63946] hover:bg-[#e63946]/10 transition-all duration-300">
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Collections — pulled live from Admin Panel */}
          <div>
            <h4 className="font-semibold text-xs tracking-widest uppercase text-gray-300 mb-5">Collections</h4>
            {collections.length > 0 ? (
              <ul className="space-y-3">
                {collections.slice(0, 5).map((col) => (
                  <li key={col.id}><Link to={`/collections/${col.slug || col.id}`} className="text-gray-400 text-sm hover:text-[#e63946] transition-colors flex items-center gap-2 group">
                    <span className="w-4 h-px bg-gray-600 group-hover:bg-[#e63946] group-hover:w-6 transition-all duration-300"/>
                    {col.name}
                  </Link></li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 text-sm">No collections yet</p>
            )}
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-xs tracking-widest uppercase text-gray-300 mb-5">Company</h4>
            <ul className="space-y-3">
              {links.company.map(({ label, to }) => (
                <li key={to}><Link to={to} className="text-gray-400 text-sm hover:text-[#e63946] transition-colors flex items-center gap-2 group">
                  <span className="w-4 h-px bg-gray-600 group-hover:bg-[#e63946] group-hover:w-6 transition-all duration-300"/>
                  {label}
                </Link></li>
              ))}
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="font-semibold text-xs tracking-widest uppercase text-gray-300 mb-5">Policies</h4>
            <ul className="space-y-3">
              {links.policies.map(({ label, to }) => (
                <li key={to}><Link to={to} className="text-gray-400 text-sm hover:text-[#e63946] transition-colors flex items-center gap-2 group">
                  <span className="w-4 h-px bg-gray-600 group-hover:bg-[#e63946] group-hover:w-6 transition-all duration-300"/>
                  {label}
                </Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-gray-800 py-5">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-3 text-gray-500 text-xs">
          <p>© {new Date().getFullYear()} SitSmart. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <span>Payment Methods:</span>
            {['JazzCash', 'EasyPaisa', 'Bank Transfer', 'COD'].map(m => (
              <span key={m} className="border border-gray-700 px-2 py-1 text-xs">{m}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
